{
  "AUDIT_LOGS": {
    "HEADER": "Audit-Protokolle",
    "HEADER_BTN_TXT": "Audit-Protokolle hinzufügen",
    "LOADING": "Audit-Protokolle abrufen",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Es gibt keine Elemente, die dieser Abfrage entsprechen",
    "SIDEBAR_TXT": "<p><b>Auditprotokolle</b> </p><p> Auditprotokolle sind Spuren für Ereignisse und Aktionen in einem Chatwoot-System. </p>",
    "LIST": {
      "404": "Es gibt keine Audit-Protokolle in diesem Konto.",
      "TITLE": "Audit-Protokolle verwalten",
      "DESC": "Auditprotokolle sind Spuren für Ereignisse und Aktionen in einem Chatwoot-System.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Action",
        "IP_ADDRESS": "IP-Adresse"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Audit-Protokolle erfolgreich abgerufen",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "DEFAULT_USER": "System",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} invited {invitee} to the account as an {role}",
      "EDIT": {
        "SELF": "{agentName} changed their {attributes} to {values}",
        "OTHER": "{agentName} changed {attributes} of {user} to {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} signed in",
      "SIGN_OUT": "{agentName} signed out"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "DELETE": "{agentName} deleted conversation #{id}"
    }
  }
}
